/**
 * Method to clone array of object for one level hierarchy
 * @param array value of array which is to be cloned
 */
export const cloneArray = (array: any[]) => {
    return array.map(item => { return { ...item }; });
};

/**
 * Get calculated date based unit and count
 * @param day
 * @param unit
 * @param count
 * @param isStart
 */
export const getCalculatedDate = (day: Date, unit: string, count: number, isStart: boolean = true) => {
    const fromDate = new Date(day);
    const toDate = new Date(fromDate);
    let seconds = 0;
    const parsedCount = parseInt(count.toString());
    if (unit === 'Year') {
        toDate.setFullYear(fromDate.getFullYear() + (isStart ? parsedCount : parsedCount * -1));
    } else if (unit === 'Month') {
        toDate.setMonth(fromDate.getMonth() + (isStart ? parsedCount : (parsedCount * -1)));
    } else if (unit === 'Week') {
        toDate.setDate(toDate.getDate() + (7 * (isStart ? parsedCount : (parsedCount * -1))));
    } else if (unit === 'Day') {
        toDate.setHours(toDate.getHours() + (24 * (isStart ? parsedCount : (parsedCount * -1))));
    } else if (unit === 'Hour') {
        toDate.setHours(toDate.getHours() + (isStart ? parsedCount : (parsedCount * -1)));
    } else if (unit === 'Minute') {
        toDate.setMinutes(toDate.getMinutes() + (isStart ? parsedCount : (parsedCount * -1)));
    } else if (unit === 'Second') {
        toDate.setSeconds(toDate.getSeconds() + (isStart ? parsedCount : (parsedCount * -1)));
    } else if (unit === 'Millisecond') {
        toDate.setMilliseconds(toDate.getMilliseconds() + (isStart ? parsedCount : (parsedCount * -1)));
    }

    if (count % 1 !== 0) {
        seconds = getMillisecond(count % 1, unit);
        toDate.setTime(toDate.getTime() + seconds);
    }
    return toDate;
};

export const getReverseCalculatedDate = (day: Date, unit: string, count: number, isStart: boolean = true) => {
    const toDate = new Date(day);
    const fromDate = new Date(toDate);
    let seconds = 0;
    const parsedCount = parseInt(count.toString());
    if (unit === 'Year') {
        toDate.setFullYear(fromDate.getFullYear() - (isStart ? parsedCount : parsedCount * -1));
    } else if (unit === 'Month') {
        toDate.setMonth(fromDate.getMonth() - (isStart ? parsedCount : (parsedCount * -1)));
    } else if (unit === 'Week') {
        toDate.setDate(toDate.getDate() - (7 * (isStart ? parsedCount : (parsedCount * -1))));
    } else if (unit === 'Day') {
        toDate.setHours(toDate.getHours() - (24 * (isStart ? parsedCount : (parsedCount * -1))));
    } else if (unit === 'Hour') {
        toDate.setHours(toDate.getHours() - (isStart ? parsedCount : (parsedCount * -1)));
    } else if (unit === 'Minute') {
        toDate.setMinutes(toDate.getMinutes() - (isStart ? parsedCount : (parsedCount * -1)));
    } else if (unit === 'Second') {
        toDate.setSeconds(toDate.getSeconds() - (isStart ? parsedCount : (parsedCount * -1)));
    } else if (unit === 'Millisecond') {
        toDate.setMilliseconds(toDate.getMilliseconds() - (isStart ? parsedCount : (parsedCount * -1)));
    }

    if (count % 1 !== 0) {
        seconds = getMillisecond(count % 1, unit);
        toDate.setTime(toDate.getTime() - seconds);
    }
    return toDate;
};

/**
 * To get difference between two date with specific units
 * @param startTime Start time
 * @param endTime End Time
 * @param dateUnit Require Unit like Day, Month, Year
 */
export const getDateDiffUnit = (startTime: Date, endTime: Date, dateUnit: string) => {
    let diff = 0;
    if (startTime.getTime() > endTime.getTime()) {
        return 0;
    } else {
        diff = endTime.getTime() - startTime.getTime();
    }
    if (dateUnit === 'Year') {
        return diff / (365 * 24 * 60 * 60 * 1000);
    } else if (dateUnit === 'Month') {
        return diff / (30 * 24 * 60 * 60 * 1000);
    } else if (dateUnit === 'Week') {
        return diff / (7 * 24 * 60 * 60 * 1000);
    } else if (dateUnit === 'Day') {
        return diff / (24 * 60 * 60 * 1000);
    } else if (dateUnit === 'Hour') {
        return diff / (60 * 60 * 1000);
    } else if (dateUnit === 'Minute') {
        return diff / (60 * 1000);
    } else if (dateUnit === 'Second') {
        return diff / 1000;
    } else if (dateUnit === 'Millisecond') {
        return diff;
    }
};

/**
* Get end time from start date based on time range and unit
* @param day start date
* @param unit date unit like year, month , day, week
* @param count value to be added from start date
*/
export const getEndTime = (day: Date, unit: string, count: number) => {
    const newDate = new Date(day);
    if (unit === 'Year') {
        newDate.setFullYear(newDate.getFullYear() + count);
    } else if (unit === 'Month') {
        newDate.setMonth(newDate.getMonth() + count);
    } else if (unit === 'Week') {
        newDate.setDate(newDate.getDate() + (count * 7));
    } else if (unit === 'Day') {
        newDate.setDate(newDate.getDate() + count);
    } else if (unit === 'Hour') {
        newDate.setHours(newDate.getHours() + count);
    } else if (unit === 'Minute') {
        newDate.setMinutes(newDate.getMinutes() + count);
    } else if (unit === 'Second') {
        newDate.setSeconds(newDate.getSeconds() + count);
    } else if (unit === 'Millisecond') {
        newDate.setMilliseconds(newDate.getMilliseconds() + count);
    }
    return newDate;
};

/**
 * Method to index of object based on date from collection
 * @param day date value
 * @param data array of data
 * @param dateField key name of date property
 * @param isStart for start date or end date
 */
export const getIndexByValue = (
    value: Date | number,
    data: any[] = [],
    field: string,
    isStart: boolean | string,
    tooTipMid:boolean
) => {
    if(!tooTipMid){
        const type = value instanceof Date ? 'DateTime' : 'Number';
        const index = data.findIndex((item) => {
            if (type === 'DateTime') {
                return item[field].getTime() >= (value as Date).getTime();
            } else {
                return item[field] >= value;
            }
        });

        if (index === 0) {
            return 0;
        } else if (index === -1) {
            return data.length - 1;
        } else if (
            (type === 'DateTime' &&
                data[index][field].getTime() === (value as Date).getTime()) ||
            (type === 'Number' && data[index][field] === value)
        ) {
            return index;
        } else if (isStart === 'Middle') {
            const after = type === 'DateTime' ? data[index][field].getTime() - (value as Date).getTime() : data[index][field] - (value as number);
            const before = type === 'DateTime' ? (value as Date).getTime() - data[index - 1][field].getTime() : (value as number) - data[index - 1][field];
            return after >= before ? index - 1 : index;
        } else {
            return isStart ? index : index - 1;
        }
    }else{
        const type = value instanceof Date ? 'DateTime' : 'Number';
        const index = data.findIndex((item) => {
            if (type === 'DateTime') {
                return item[field].getTime() >= (value as Date).getTime();
            } else {
                return item[field] >= value;
            }
        });
        if (index === 0) {
            return 0;
        } else if (index === -1) {
            return data.length - 1;
        } else if (
            (type === 'DateTime' &&
                data[index][field].getTime() === (value as Date).getTime()) ||
            (type === 'Number' && data[index][field] === value)
        ) {
            return index;
        } else if (isStart === 'Middle') {
            const after = type === 'DateTime' ? parseFloat((data[index][field].getTime() - (value as Date).getTime()).toFixed(1)) : parseFloat((data[index][field] - (value as number)).toFixed(1));
            const before = type === 'DateTime' ? parseFloat(((value as Date).getTime() - data[index - 1][field].getTime()).toFixed(1)) : parseFloat(((value as number) - data[index - 1][field]).toFixed(1));
            if( after==0){
                return index
            }else if(data[data.length-1][field] >= value){
                return -1
            }
        } else {
            return isStart ? index : index - 1;
        }
    }

};

const getMillisecond = (count: number, unit: string) => {
    const yearsDays = 365;
    const monthDays = 30;
    if (unit === 'Year') {
        return count * yearsDays * 24 * 60 * 60 * 1000;
    } else if (unit === 'Month') {
        return count * monthDays * 24 * 60 * 60 * 1000;
    } else if (unit === 'Week') {
        return count * 7 * 24 * 60 * 60 * 1000;
    } else if (unit === 'Day') {
        return count * 24 * 60 * 60 * 1000;
    } else if (unit === 'Hour') {
        return count * 60 * 60 * 1000;
    } else if (unit === 'Minute') {
        return count * 60 * 1000;
    } else if (unit === 'Second') {
        return count * 1000;
    } else if (unit === 'Millisecond') {
        return parseInt(count.toString());
    }
};

/**
 * To find value of variable was null or undefined
 * @param value value
 */
export const isNullOrUndefined = (value: any) => {
    return value === null || value === undefined;
};

/**
 * Method to read text from locale text configuration
 */
export const getLabelByKey = (key: string, labelObject: any): string => {
    const formattedKey = key.split('-').join('');
    for (const labelKey in labelObject) {
        if (Object.prototype.hasOwnProperty.call(labelObject, labelKey)) {
            if (formattedKey.toLocaleLowerCase() === labelKey.toLocaleLowerCase()) {
                // @ts-ignore
                return labelObject[labelKey];
            }
        }
    }
    return '';
}